import Cell from './Cell';
const seeds = [
    {
        name: 'Glider',
        info: 'https://conwaylife.com/wiki/Glider',
        value: [
            new Cell(2, 1, 'alive'),
            new Cell(3, 2, 'alive'),
            new Cell(1, 3, 'alive'),
            new Cell(2, 3, 'alive'),
            new Cell(3, 3, 'alive'),
        ]
    },
    {
        name: 'Gosper Glider Gun',
        info: 'https://conwaylife.com/wiki/Gosper_glider_gun',
        value: [
            new Cell(26, 2, 'alive'),
            new Cell(24, 3, 'alive'),
            new Cell(26, 3, 'alive'),
            new Cell(14, 4, 'alive'),
            new Cell(15, 4, 'alive'),
            new Cell(22, 4, 'alive'),
            new Cell(23, 4, 'alive'),
            new Cell(36, 4, 'alive'),
            new Cell(37, 4, 'alive'),
            new Cell(13, 5, 'alive'),
            new Cell(17, 5, 'alive'),
            new Cell(22, 5, 'alive'),
            new Cell(23, 5, 'alive'),
            new Cell(36, 5, 'alive'),
            new Cell(37, 5, 'alive'),
            new Cell(2, 6, 'alive'),
            new Cell(3, 6, 'alive'),
            new Cell(12, 6, 'alive'),
            new Cell(18, 6, 'alive'),
            new Cell(22, 6, 'alive'),
            new Cell(23, 6, 'alive'),
            new Cell(2, 7, 'alive'),
            new Cell(3, 7, 'alive'),
            new Cell(12, 7, 'alive'),
            new Cell(16, 7, 'alive'),
            new Cell(18, 7, 'alive'),
            new Cell(19, 7, 'alive'),
            new Cell(24, 7, 'alive'),
            new Cell(26, 7, 'alive'),
            new Cell(12, 8, 'alive'),
            new Cell(18, 8, 'alive'),
            new Cell(26, 8, 'alive'),
            new Cell(13, 9, 'alive'),
            new Cell(17, 9, 'alive'),
            new Cell(14, 10, 'alive'),
            new Cell(15, 10, 'alive'),
        ]
    },
    {
        name: 'Simkin Glider Gun',
        info: 'https://conwaylife.com/wiki/Simkin_glider_gun',
        value: [
            new Cell(7, 15, 'alive'),
            new Cell(8, 15, 'alive'),
            new Cell(14, 15, 'alive'),
            new Cell(15, 15, 'alive'),
            new Cell(7, 16, 'alive'),
            new Cell(8, 16, 'alive'),
            new Cell(14, 16, 'alive'),
            new Cell(15, 16, 'alive'),
            new Cell(11, 18, 'alive'),
            new Cell(12, 18, 'alive'),
            new Cell(11, 19, 'alive'),
            new Cell(12, 19, 'alive'),
            new Cell(29, 24, 'alive'),
            new Cell(33, 24, 'alive'),
            new Cell(28, 25, 'alive'),
            new Cell(33, 25, 'alive'),
            new Cell(34, 25, 'alive'),
            new Cell(27, 26, 'alive'),
            new Cell(28, 26, 'alive'),
            new Cell(34, 26, 'alive'),
            new Cell(35, 26, 'alive'),
            new Cell(38, 26, 'alive'),
            new Cell(39, 26, 'alive'),
            new Cell(28, 27, 'alive'),
            new Cell(29, 27, 'alive'),
            new Cell(34, 27, 'alive'),
            new Cell(38, 27, 'alive'),
            new Cell(39, 27, 'alive'),
            new Cell(29, 28, 'alive'),
        ]
    },
    {
        name: 'R-pentomino',
        info: 'https://www.conwaylife.com/wiki/R-pentomino',
        value: [
            new Cell(27, 31, 'alive'),
            new Cell(28, 31, 'alive'),
            new Cell(26, 32, 'alive'),
            new Cell(27, 32, 'alive'),
            new Cell(27, 33, 'alive'),
        ]
    },
    {
        name: 'Blooming Honey Farm',
        info: 'https://www.conwaylife.com/wiki/Honey_farm',
        value: [
            new Cell(12, 11, 'alive'),
            new Cell(13, 12, 'alive'),
            new Cell(11, 13, 'alive'),
            new Cell(12, 13, 'alive'),
            new Cell(13, 13, 'alive'),
            new Cell(22, 21, 'alive'),
            new Cell(21, 22, 'alive'),
            new Cell(23, 22, 'alive'),
            new Cell(21, 23, 'alive'),
            new Cell(23, 23, 'alive'),
            new Cell(22, 24, 'alive'),
        ]
    },
    {
        name: 'Queen Bee Shuttle',
        info: 'https://www.conwaylife.com/wiki/Queen_bee_shuttle',
        value: [
            new Cell(17, 16, 'alive'),
            new Cell(15, 17, 'alive'),
            new Cell(17, 17, 'alive'),
            new Cell(14, 18, 'alive'),
            new Cell(16, 18, 'alive'),
            new Cell(8, 19, 'alive'),
            new Cell(9, 19, 'alive'),
            new Cell(13, 19, 'alive'),
            new Cell(16, 19, 'alive'),
            new Cell(28, 19, 'alive'),
            new Cell(29, 19, 'alive'),
            new Cell(8, 20, 'alive'),
            new Cell(9, 20, 'alive'),
            new Cell(14, 20, 'alive'),
            new Cell(16, 20, 'alive'),
            new Cell(28, 20, 'alive'),
            new Cell(29, 20, 'alive'),
            new Cell(15, 21, 'alive'),
            new Cell(17, 21, 'alive'),
            new Cell(17, 22, 'alive'),
        ]
    },
    {
        name: 'Honey Farm Dance',
        value: [
            new Cell(44, 17, 'alive'),
            new Cell(43, 18, 'alive'),
            new Cell(45, 18, 'alive'),
            new Cell(43, 19, 'alive'),
            new Cell(45, 19, 'alive'),
            new Cell(44, 20, 'alive'),
            new Cell(39, 22, 'alive'),
            new Cell(40, 22, 'alive'),
            new Cell(48, 22, 'alive'),
            new Cell(49, 22, 'alive'),
            new Cell(38, 23, 'alive'),
            new Cell(41, 23, 'alive'),
            new Cell(47, 23, 'alive'),
            new Cell(50, 23, 'alive'),
            new Cell(39, 24, 'alive'),
            new Cell(40, 24, 'alive'),
            new Cell(44, 24, 'alive'),
            new Cell(48, 24, 'alive'),
            new Cell(49, 24, 'alive'),
            new Cell(43, 25, 'alive'),
            new Cell(44, 25, 'alive'),
            new Cell(45, 25, 'alive'),
            new Cell(44, 26, 'alive'),
            new Cell(43, 27, 'alive'),
            new Cell(45, 27, 'alive'),
            new Cell(43, 28, 'alive'),
            new Cell(45, 28, 'alive'),
            new Cell(44, 29, 'alive'),
        ]
    },
    {
        name: 'Empty',
        value: []
    }
];
export default seeds;
